export const TESTIMONIALS = [
  {
    image: "/assets/images/afanon.jpg",
    name: "حسن القحطاني",
    role: "مدير متجر ملابس",
    quote: "النظام سهّل علينا. ورتب الشغل",
    rating: 4.5,
  },
  {
    image: "/assets/images/Logo_2.jpg",
    name: "محمد الشهراني",
    role: "مالك مقهى",
    quote: "واجهة نقطة البيع ممتازة...",
    rating: 5,
  },
  {
    image: "/assets/images/Logo_3.jpg",
    name: "أحمد علي",
    role: "مسؤول مالي",
    quote: "تكامل الفوترة الإلكترونية سلس...",
    rating: 4.5,
  },
  {
    image: "/assets/images/MoraLogo.png",
    name: "حسين عسيري",
    role: "مدير مطعم",
    quote: "نسخة المطاعم مناسبة جدًا...",
    rating: 5,
  },
  {
    image: "/assets/images/Logo_6.png",
    name: "محمد المحمد",
    role: "صاحب سوبرماركت",
    quote: "انخفضت الأخطاء في الكاشير...",
    rating: 4.5,
  },
  {
    image: "/assets/images/3.png",
    name: "علي غانم",
    role: "مالك محل عصائر",
    quote: "سهولة الاستخدام وتعدد التقارير...",
    rating: 5,
  },
];
